import React from 'react';

import SvgContainer from '../SvgContainer';

const Play = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100959)">
                <path d="M6.4 10.6C6.4 11.012 6.87038 11.2472 7.2 11L10.6667 8.4C10.9333 8.2 10.9333 7.8 10.6667 7.6L7.2 5C6.87038 4.75279 6.4 4.98798 6.4 5.4V10.6ZM8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100959">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Play;
